import { Component, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxPopupComponent } from 'devextreme-angular';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { SessionContextService } from 'src/app/services/session-context.service';
import { AutoLogoutService } from '../../../services/auto-logout.service';

@Component({
  selector: 'autoLogoutWarningMsgBox',
  templateUrl: './autoLogoutWarningMsgBox.component.html',
  styleUrls: ['./autoLogoutWarningMsgBox.component.scss'],
})
export class AutoLogoutWarningMsgBoxComponent implements OnInit, OnDestroy {
  public timeLeft = 90;

  @Input() public popupVisible: boolean = false;
  @Input() public secondsBeforeLogout: number = 90;

  onTimeLeftChanged: Subscription;
  private logoutWarning: Subscription;
  onAutoLogoutTriggered: Subscription;

  @ViewChild("autoLogoutWarningPopup") popup: DxPopupComponent;

  constructor(
    public autoLogoutService: AutoLogoutService, public session: SessionContextService, public router: Router) {
    this.timeLeft = this.secondsBeforeLogout;
  }

  ngOnInit() {
    this.onTimeLeftChanged = timer(1000, 1000).subscribe(() => {
      if (this.timeLeft > 0) {
        this.timeLeft = this.timeLeft - 1;
      }
    });

    this.onAutoLogoutTriggered = this.autoLogoutService.autoLogoutTriggered.subscribe((r) => {
      if (r === true) {
        this.popup.visible = false;
        this.session
          .selectEmployee(-1, null)
          .pipe(take(1))
          .subscribe((r) => {
            this.router.navigate([r.Msg]);
          });
      }
    });

    // Close dialog if we get a event where showAutoLogoutWarningDlg.next = 0.
    this.logoutWarning = this.autoLogoutService.showAutoLogoutWarningDlg.subscribe((secondsBeforeLogout: number) => {
      if (secondsBeforeLogout > 0) {
        // Show Warning Dialog if seconds before logout > 0
        this.timeLeft = this.secondsBeforeLogout;
        this.popup.visible = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.onTimeLeftChanged) {
      this.onTimeLeftChanged.unsubscribe();
    }
    if (this.logoutWarning) {
      this.logoutWarning.unsubscribe();
    }
    if (this.onAutoLogoutTriggered) {
      this.onAutoLogoutTriggered.unsubscribe();
    }
  }

  btnOk(e) {
    this.autoLogoutService.continueSession();
    this.popupVisible = false;
  }
}
